<template>
  <div>

    <data-tables
            v-if="orderedProductionRuns"
            class="first-checkbox"
            :tableClass="tableClass"
            :columns="getColumns"
            :rows="orderedProductionRuns"
            :drawTrigger="drawTick"
            tableID="job-activity-dt"
            routerLinkClass="dt-router-link"
            :tableInitOptions="tableInitOptions"
            :customFilters="customFilters"
            @rowSelected="stopRun"
    />

  </div>
</template>

<script>

  import {mapGetters} from 'vuex';
  import {dataTables} from '../../mixins/dataTables';
  import {swalJobs} from '../../mixins/swalJobs';
  import translation from '../../i18n';
  import timeCalc from '../../mixins/timeCalc';
  import {toDateVal} from '../../utils/dateUtils';
  // @vuese
  // @group StartStop
  // This component shows the current and historical productionRuns of currently showing job

  export default {
    name: 'JobActivityHistory',
    props: {
      //@vuese
      // Passed in job to get the productionRuns from
      job: {
        required: true,
        type: Object,
        default: null
      }
    },
    data() {
      return {
        productionRuns: [],
        customFilters: [],
        drawTick: 0
      };
    },
    firestore() {
      return {
        productionRuns: this.$FB.collection('productionRuns').where('jobId', '==', this.job.id).where('companyId', '==', this.getClaims.companyId)
      };
    },
    mixins: [dataTables, swalJobs, timeCalc],
    methods: {
      /**
       * @vuese
       * This finds out if the if the number of units or timespent it produced within the desired targets.
       *
       * @arg `amountProduced` the amount of units produced during the run
       * @arg `startTimestamp` the date object of the time that the run started
       * @arg `endTimestamp` the date object of the time that the run ended
       * @arg `targetPerMs` the amount of milliseconds it takes to produce one unit
       *
       * @returns {Boolean}
       */
      getProductionRunResult(amountProduced, startTimestamp, endTimestamp, targetPerMs) {
        if(this.getConfig.startStop.productivity !== 'amount' || !endTimestamp) {
          return true;
        }
        let targetForThisDuration = this.gettargetForDuration(startTimestamp, endTimestamp, targetPerMs);
        return targetForThisDuration <= amountProduced;
      },
      /**
       * @vuese
       * Calculates the number of units that have to been produced given a start and an endtime.
       * We floor the target, because if the target is 10.1 per hour, you can make 10 per hour.
       * But to reach 10.1 you'd have to produce 11 units, which is not possible because 10.1 is the limit
       * of the machine.
       *
       * @arg `startTimestamp` the date object of the time that the run started
       * @arg `endTimestamp` the date object of the time that the run ended
       * @arg `targetPerMs` the amount of milliseconds it takes to produce one unit
       *
       * @returns {Number}
       */
      gettargetForDuration(startTimestamp, endTimestamp, targetPerMs) {
        return Math.floor((endTimestamp.toDate().getTime() - startTimestamp.toDate().getTime()) / targetPerMs);
      },

      //@vuese
      // Stop currently running productionRun
      stopRun(data) {
        const self = this;
        let job = this.job;
        if(this.getConfig.startStop.productivity == 'time') {
          // this.swalAmountProduced(selectedOrder).then(result => {
          this.swalJobIsDoneCheck(data.uid).then(res => {
            if(res.dismiss == 'backdrop') {
              return;
            }
            if(res.value) {
              this.$store.dispatch('jobs/set', {
                id: data.jobId,
                status: 'finished',
                finishedBy: this.getMe.id,
                userName: this.getMe.displayName ? this.getMe.displayName : this.getMe.email

              });
            }

            this.setTimebasedJobStopped(job, 'finished', new Date());
            this.swalToastSuccess(this.$t('swal.toast.jobStopped') + ' ' + job.uid);
          });


        } else {
          // The orderline is running: so we want to stop it.
          this.swalAmountProduced(job).then(result => {
            if(result.value) {
              let amountProducedDuringRun = parseInt(result.value);
              let amountProduced = 0;

              if(job.amountProduced) {
                amountProduced = job.amountProduced += amountProducedDuringRun;
              } else {
                amountProduced = amountProducedDuringRun;
              }

              if(amountProduced > job.amount) {
                this.swalAmountProducedWarning().then(result => {
                  if(result.value) {
                    this.$store.dispatch('productionRuns/set', {
                      id: data.id,
                      userId: this.getMe.id,
                      amountProduced: parseInt(amountProducedDuringRun),
                      userName: this.getMe.displayName ? this.getMe.displayName : this.getMe.email,

                      productionEnd: new Date(),
                      explanation: {note: '', userId: null}
                    }).then(() => {
                      this.$store.dispatch('jobs/set', {
                        id: job.id,
                        status: 'finished',
                        finishedBy: this.getMe.id,
                        userName: this.getMe.displayName ? this.getMe.displayName : this.getMe.email

                      });
                    });
                    this.swalToastSuccess(this.$t('swal.toast.jobStopped') + ' ' + job.uid);
                  }
                });
              } else {

                // Clear selected orderline and product
                this.$store.dispatch('productionRuns/set', {
                  id: data.id,
                  userId: this.getMe.id,
                  amountProduced: parseInt(amountProducedDuringRun),
                  productionEnd: new Date(),
                  userName: this.getMe.displayName ? this.getMe.displayName : this.getMe.email,

                  explanation: {note: '', userId: null}
                });
                let jobStatus;
                amountProduced === job.amount ? jobStatus = 'finished' : jobStatus = 'stopped';
                if(jobStatus == 'finished') {
                  this.$store.dispatch('jobs/set', {
                    id: job.id,
                    status: 'finished',
                    userName: this.getMe.displayName ? this.getMe.displayName : this.getMe.email,

                    finishedBy: this.getMe.id
                  });
                }
                this.swalToastSuccess(this.$t('swal.toast.jobStopped') + ' ' + job.uid);
              }
            }
          });
        }
      }
    },
    computed: {
      orderedProductionRuns() {
        return _.orderBy(this.productionRuns, ['productionEnd'], ['desc']);
      },
      ...mapGetters('company', [
        'getConfig'
      ]),
      ...mapGetters('productionRuns', [
        'getProductionRunsOfJob',
        'getProductivityProgressBar',
        'getProductionRunsOfWorkflow',
        'getProducedAmountOfJobId'
      ]),
      ...mapGetters('workflows', [
        'getWorkflows',
        'getWorkflowName',
        'getWorkflowsIdName',
        'getWorkflowMultiOrderlinePossible',
        'getWorkflowMultiOrderPossible',
        'getWorkflowMultiJobPossible'
      ]),
      ...mapGetters('users', [
        'getSelectedWorkflow',
        'getClaims',
        'getMe',
        'getRunningJob',
        'getOrderlineWorkflowProduct',
        'getSelectedWorkflowLength'
      ]),
      // @vuese
      // Sets up the columns for datatables package from https://git.motivate.nl/js-awesome/motivate-framework-components/blob/v2/src/components/DataTable.vue
      getColumns() {
        const self = this;
        let statusAndButtonColumns = [

          {
            data: {
              _: null,
              sort: null
            },
            name: this.$t('productivity.result'),
            searchable: false,
            className: 'alignCenter',
            orderable: true,
            visible: true,
            render(data, type) {
              if(type == 'sort') {
                return data.productionEnd ? data.productionEnd : null;
              }
              if(type !== 'sort') {
                if(!data.productionEnd || data.productionEnd == undefined) {
                  // return `<span class="runDot runRunning bouncingAnimation" ></span>`
                  return `<i class="fas fa-spinner fa-spin"></i>`;

                }
                let passed = self.getProductionRunResult(data.amountProduced, data.productionStart, data.productionEnd, data.target);
                let explanationNoteNeeded;
                return `<span class="runDot ${passed ? 'runSuccess' : 'runFailed'} ${explanationNoteNeeded ? 'bouncingAnimation' : ''}" ${explanationNoteNeeded ? 'title="' + self.$t('productivity.explanationNeeded') + '"' : ''}></span>`;
              }
            }
          },
          {
            data: null,
            name: this.$t('productivity.workflow'),
            searchable: false,
            orderable: true,
            render(data) {
              let workflowName = self.getWorkflowName(data.workflowId);
              return workflowName;
            }
          },
          {
            data: null,
            name: this.$t('productivity.startTime'),
            searchable: false,
            width: '10%',
            orderable: true,
            render(data) {
              return moment(toDateVal(data.productionStart)).format('DD-MM-YYYY HH:mm');
            }
          },
          {
            data: null,
            name: this.$t('productivity.stopTime'),
            searchable: false,
            width: '10%',
            sortable: true,
            render(data) {
              if(!data.productionEnd) {
                return 'Running';
              }
              return moment(toDateVal(data.productionEnd)).format('DD-MM-YYYY HH:mm');

            }
          },
          {
            data: null,
            name: this.$t('productivity.timeSpent'),
            searchable: false,
            width: '10%',
            sortable: true,
            render(data) {
              if(!data.productionEnd) {
                let diff = moment().diff(moment(toDateVal(data.productionStart)));
                let converted = self.convertMs(diff);
                return `${converted.hrs}:${converted.min}:${converted.sec}`;
              }
              let diff = moment(toDateVal(data.productionEnd)).diff(moment(toDateVal(data.productionStart)));
              let converted = self.convertMs(diff);
              return `${converted.hrs}:${converted.min}:${converted.sec}`;
            }
          },
          {
            data: null,
            name: this.$t('productivity.unitsProduced'),
            searchable: false,
            width: '10%',
            sortable: true,
            visible: this.getConfig.progressDefaultKpi ? 1 : 0,
            render(data) {
              if(!data.productionEnd) {
                return 'Running';
              }

              return data.amountProduced ? data.amountProduced : 0;
            }
          },
          {
            data: null,
            name: this.$t('ui.user'),
            searchable: false,
            sortable: true,
            visible: true,
            render(data) {
              return `${data.userName ? data.userName : ' '}`;
            }
          },
          {
            data: null,
            name: '',
            searchable: false,
            sortable: true,
            visible: false, // this row is turned off for now
            render(data) {
              if(!data.productionEnd) {
                return '<button class="btn btn-danger get-data"><i class="fas fa-stop  get-data"></i> ' + translation.t('jobs.table.stop') + '</button>';
              }
              return ` `;
            }
          }

        ];


        return statusAndButtonColumns;
      }
    },
    created() {

      this.tableInitOptions.order = [[3, 'desc']];
      this.tableInitOptions.bStateSave = false;
      this.tableInitOptions.createdRow = function (row, data, dataIndex) {
        if(!data.productionEnd) {
          // Set the data-status attribute, and add a class
          $(row).addClass('job-running');
        }
      };
      this._tickInterval = setInterval(() => { this.drawTick++; }, 1000);
    },
    beforeDestroy() {
      clearInterval(this._tickInterval);
    }
  };
</script>

<style scoped>

</style>